module.exports = __webpack_public_path__ + "img/dunning.1ad5b6d5.svg";